import React__default, { useCallback } from 'react';
import { useToolbarContext } from '../../hooks/useToolbarContext.mjs';
import { Button as Button$1 } from '../../../ToolbarUI/components/Button/Button.mjs';

function Button({
  onAction,
  type,
  ...props
}) {
  const {
    onActionAnyItem
  } = useToolbarContext();
  const handleAction = useCallback(() => {
    onActionAnyItem === null || onActionAnyItem === void 0 ? void 0 : onActionAnyItem(type);
    onAction === null || onAction === void 0 ? void 0 : onAction();
  }, [onAction, onActionAnyItem, type]);
  return /*#__PURE__*/React__default.createElement(Button$1, Object.assign({}, props, {
    onAction: handleAction
  }));
}

export { Button };
